// Utility function to create autocomplete filter objects
export function createAutocompleteFilter(fieldKey: string, fieldName: string, fieldFullName: string, label: string) {
  return {
    type: "autocomplete",
    fieldKey,
    fieldName,
    fieldFullName,
    multiple: true,
    key: `autoComplete-${fieldKey}`,
    label,
    items: [],
  };
}
